import { createFileRoute } from '@tanstack/react-router';
import { WhiteLabelingIndex } from '@/pages/settings/WhiteLabelingIndex';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/settings/white-labeling')({
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['companySettings.manageProfile'] }),
	component: WhiteLabelingIndex,
});
